import RadioButton from '@/app/components/common/RadioButton'
import Text from '@/app/components/common/Text'
import { RATING } from '@/app/constants'
import { Filters } from '@/app/types'
import { useTranslations } from 'next-intl'
import { FC } from 'react'

interface GuestRatingFilterProps {
	localValue: Filters
	availableFilters: { [key: string]: number }
	handleRatingChange: (ratingValue: number, name: string) => void
}

const GuestRatingFilter: FC<GuestRatingFilterProps> = ({
	localValue,
	availableFilters,
	handleRatingChange,
}) => {
	const t = useTranslations('Keywords')

	const getCumulativeCount = (ratingThreshold: number): number => {
		if (ratingThreshold === 0)
			return Object.values(availableFilters).reduce(
				(sum, count) => sum + count,
				0
			)

		return Object.entries(availableFilters).reduce((sum, [rating, count]) => {
			const ratingValue = parseInt(rating, 10)
			return ratingValue >= ratingThreshold ? sum + count : sum
		}, 0)
	}

	return (
		<div className="hotel-list-filters__section">
			<Text size="lg" font={'semibold'} className="hotel-list-filters__title">
				{t('guestRatingFilter')}
			</Text>
			<ul className="hotel-list-filters__rating">
				<div>
					{Object.entries(RATING).map(([ratingKey, ratingText]) => {
						const ratingValue = parseInt(ratingKey, 10)
						const cumulativeCount = getCumulativeCount(ratingValue)

						return (
							<div
								key={ratingKey}
								className="hotel-list-filters__rating-value hotel-list-filters__item"
							>
								<RadioButton
									key={`rating-${ratingValue}-${localValue.rating[0]}`}
									checked={
										(ratingValue === 0 && localValue.rating.length === 0) ||
										ratingValue === localValue.rating[0]
									}
									onChange={() => handleRatingChange(ratingValue, ratingText)}
									label={`${t(ratingText)} ${
										ratingValue > 0 ? ratingValue + '+' : ''
									}${
										ratingValue > 0 && cumulativeCount > 0
											? ` (${cumulativeCount})`
											: ''
									}`}
									value={ratingKey}
									name="rating"
									variant="main-dark"
									bold={false}
									testId={`rating-${ratingValue}`}
								/>
							</div>
						)
					})}
				</div>
			</ul>
		</div>
	)
}

export default GuestRatingFilter
